import React from 'react';
import { FeatureFlag } from 'src/shared/design-system/FeatureFlag';
import { PromoContentType } from './types';

import { BulkDiscountPromoContent } from './BulkDiscountPromoContent';

export const PromoContent: React.FC<PromoContentType> = (props) => (
  <FeatureFlag name='bulkDiscountEnabled' control={<></>}>
    <BulkDiscountPromoContent {...props} />
  </FeatureFlag>
);
